var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('el-row',{staticStyle:{"padding-top":"24px"}},[_c('el-col',[_c('span',{staticClass:"title-text"},[_vm._v("ราคาแพ็คเก็จ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }